import { useEffect } from 'preact/hooks';
import { useLocation } from 'wouter-preact';
import { Button } from '../ui/Button.jsx';
import { Sheet } from '../ui/Sheet.jsx';

export function HandoverDone({ familyKey }) {
  const [, setLoc] = useLocation();
  useEffect(() => {
    const t = setTimeout(() => setLoc('/scan'), 3000);
    return () => clearTimeout(t);
  }, []);
  return (
    <Sheet>
      <div style={{ textAlign: 'center', padding: 32 }}>
        <div style={{ fontSize: 64, color: 'var(--ok)' }}>✓</div>
        <div style={{ fontSize: 18, marginTop: 8 }}>Handover recorded</div>
        <Button block style={{ marginTop: 16 }} onClick={() => setLoc('/scan')}>
          Next scan
        </Button>
      </div>
    </Sheet>
  );
}
